export const types = {
  SET_CARDS: "SET_CARDS",
  SAVE_CARD: "SAVE_CARD",
  DELETE_CARD: "DELETE_CARD",
};
